// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"804f3a24","408":"e2f40916","587":"941bd05d","639":"3c422a44"}[chunkId] + ".chunk.js";
};